import { useDropdown } from "@/hooks";
import styles from "@/styles/DropdownMenu.module.scss";
import classnames from "classnames";
import { useCallback, useEffect, useState } from "react";
import IconArrow from "../svgs/icon_arrow.svg";

export default function DropdownSelect({
  options,
  right = false,
  mouseOver = false,
  defaultValue,
  onSelect,
  disabled = false,
  className,
}) {
  const { buttonRef, contentRef, show, setShow, listeners } = useDropdown({
    mouseOver,
  });
  const [selected, setSelected] = useState();

  const handleMouseOver = useCallback(() => {
    if (!disabled) {
      listeners.handleMouseOver();
    }
  }, [listeners, disabled]);

  const handleMouseLeave = useCallback(() => {
    if (!disabled) {
      listeners.handleMouseLeave();
    }
  }, [listeners, disabled]);

  const handleClick = useCallback(() => {
    if (!disabled) {
      listeners.handleClick();
    }
  }, [listeners, disabled]);

  const handleSelect = useCallback(
    (value) => {
      return () => {
        if (!disabled) {
          const selectOption = options.find((option) => option.value == value);
          setSelected(selectOption);
          setShow(false);
          if (onSelect) {
            onSelect(selectOption);
          }
        }
      };
    },
    [disabled]
  );

  useEffect(() => {
    if (!defaultValue) {
      setSelected(options[0]);
    }
  }, [defaultValue]);

  return (
    <div
      className={classnames(styles.dropdown, className, {
        [styles.sort]: className == "sort",
      })}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
    >
      <div
        ref={buttonRef}
        className={classnames(styles.selected, { [styles.show]: show })}
        onClick={handleClick}
      >
        {selected && (
          <span>
            {selected.text}
            <span className={styles.caret}>
              <IconArrow />
            </span>
          </span>
        )}
      </div>
      <div
        ref={contentRef}
        className={classnames(styles.content, {
          [styles.show]: show,
          [styles.right]: right,
        })}
      >
        {!disabled &&
          options.map((option) => (
            <div
              key={`dropdownselect-${option.value}`}
              className={styles.option}
              onClick={handleSelect(option.value)}
            >
              {option.text}
            </div>
          ))}
      </div>
    </div>
  );
}
